"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PIVOT_TABLE_SUPPORTED_PROPERTIES = exports.GEOPUSHPIN_SUPPORTED_PROPERTIES = exports.BULLET_CHART_SUPPORTED_PROPERTIES = exports.HEATMAP_SUPPORTED_PROPERTIES = exports.TREEMAP_SUPPORTED_PROPERTIES = exports.PIECHART_SUPPORTED_PROPERTIES = exports.SCATTERPLOT_SUPPORTED_PROPERTIES = exports.BUBBLE_CHART_SUPPORTED_PROPERTIES = exports.COMBO_CHART_SUPPORTED_PROPERTIES = exports.BAR_CHART_SUPPORTED_PROPERTIES = exports.LINE_CHART_SUPPORTED_PROPERTIES = exports.COLUMN_CHART_SUPPORTED_PROPERTIES = exports.AREA_CHART_SUPPORTED_PROPERTIES = exports.BASE_CHART_SUPPORTED_PROPERTIES = exports.OPTIONAL_STACKING_PROPERTIES = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2023 GoodData Corporation
var axis_1 = require("./axis");
var BASE_PROPERTIES = [
    "dataLabels.visible",
    "dataLabels.totalsVisible",
    "grid",
    "legend",
    "colorMapping",
    "zoomInsight",
];
var BASE_X_AXIS_PROPERTIES = [
    "xaxis.rotation",
    "xaxis.labelsEnabled",
    "xaxis.visible",
    "xaxis.name.visible",
    "xaxis.name.position",
];
var BASE_Y_AXIS_PROPERTIES = [
    "yaxis.rotation",
    "yaxis.labelsEnabled",
    "yaxis.visible",
    "yaxis.name.visible",
    "yaxis.name.position",
];
var BASE_PRIMARY_AXIS_PROPERTIES = tslib_1.__spreadArrays(BASE_Y_AXIS_PROPERTIES, ["yaxis.min", "yaxis.max", "yaxis.format"]);
var BAR_PRIMARY_AXIS_PROPERTIES = tslib_1.__spreadArrays(BASE_X_AXIS_PROPERTIES, ["xaxis.min", "xaxis.max", "xaxis.format"]);
var BASE_SECONDARY_AXIS_PROPERTIES = [
    "secondary_yaxis.rotation",
    "secondary_yaxis.labelsEnabled",
    "secondary_yaxis.visible",
    "secondary_yaxis.min",
    "secondary_yaxis.max",
    "secondary_yaxis.measures",
    "secondary_yaxis.name.visible",
    "secondary_yaxis.name.position",
    "secondary_yaxis.format",
];
var BAR_SECONDARY_AXIS_PROPERTIES = [
    "secondary_xaxis.rotation",
    "secondary_xaxis.labelsEnabled",
    "secondary_xaxis.visible",
    "secondary_xaxis.min",
    "secondary_xaxis.max",
    "secondary_xaxis.measures",
    "secondary_xaxis.name.visible",
    "secondary_xaxis.name.position",
    "secondary_xaxis.format",
];
exports.OPTIONAL_STACKING_PROPERTIES = ["stackMeasures", "stackMeasuresToPercent"];
var CHART_TYPE_PROPERTIES = ["primaryChartType", "secondaryChartType", "dualAxis"];
exports.BASE_CHART_SUPPORTED_PROPERTIES = tslib_1.__spreadArrays(BASE_PROPERTIES, BASE_X_AXIS_PROPERTIES, BASE_PRIMARY_AXIS_PROPERTIES);
exports.AREA_CHART_SUPPORTED_PROPERTIES = tslib_1.__spreadArrays(exports.BASE_CHART_SUPPORTED_PROPERTIES, exports.OPTIONAL_STACKING_PROPERTIES, [
    "dataPoints.visible",
]);
exports.COLUMN_CHART_SUPPORTED_PROPERTIES = (_a = {},
    _a[axis_1.AXIS.PRIMARY] = tslib_1.__spreadArrays(exports.BASE_CHART_SUPPORTED_PROPERTIES, exports.OPTIONAL_STACKING_PROPERTIES),
    _a[axis_1.AXIS.SECONDARY] = tslib_1.__spreadArrays(BASE_PROPERTIES, BASE_X_AXIS_PROPERTIES, BASE_SECONDARY_AXIS_PROPERTIES, exports.OPTIONAL_STACKING_PROPERTIES),
    _a[axis_1.AXIS.DUAL] = tslib_1.__spreadArrays(exports.BASE_CHART_SUPPORTED_PROPERTIES, BASE_SECONDARY_AXIS_PROPERTIES, exports.OPTIONAL_STACKING_PROPERTIES),
    _a);
exports.LINE_CHART_SUPPORTED_PROPERTIES = (_b = {},
    _b[axis_1.AXIS.PRIMARY] = tslib_1.__spreadArrays(exports.BASE_CHART_SUPPORTED_PROPERTIES, ["dataPoints.visible"]),
    _b[axis_1.AXIS.SECONDARY] = tslib_1.__spreadArrays(BASE_PROPERTIES, BASE_X_AXIS_PROPERTIES, BASE_SECONDARY_AXIS_PROPERTIES, [
        "dataPoints.visible",
    ]),
    _b[axis_1.AXIS.DUAL] = tslib_1.__spreadArrays(exports.BASE_CHART_SUPPORTED_PROPERTIES, BASE_SECONDARY_AXIS_PROPERTIES, [
        "dataPoints.visible",
    ]),
    _b);
exports.BAR_CHART_SUPPORTED_PROPERTIES = (_c = {},
    _c[axis_1.AXIS.PRIMARY] = tslib_1.__spreadArrays(BASE_PROPERTIES, BASE_Y_AXIS_PROPERTIES, BAR_PRIMARY_AXIS_PROPERTIES, exports.OPTIONAL_STACKING_PROPERTIES),
    _c[axis_1.AXIS.SECONDARY] = tslib_1.__spreadArrays(BASE_PROPERTIES, BASE_Y_AXIS_PROPERTIES, BAR_SECONDARY_AXIS_PROPERTIES, exports.OPTIONAL_STACKING_PROPERTIES),
    _c[axis_1.AXIS.DUAL] = tslib_1.__spreadArrays(BASE_PROPERTIES, BASE_Y_AXIS_PROPERTIES, BAR_PRIMARY_AXIS_PROPERTIES, BAR_SECONDARY_AXIS_PROPERTIES, exports.OPTIONAL_STACKING_PROPERTIES),
    _c);
exports.COMBO_CHART_SUPPORTED_PROPERTIES = (_d = {},
    _d[axis_1.AXIS.PRIMARY] = tslib_1.__spreadArrays(exports.BASE_CHART_SUPPORTED_PROPERTIES, CHART_TYPE_PROPERTIES, exports.OPTIONAL_STACKING_PROPERTIES, [
        "dataPoints.visible",
    ]),
    _d[axis_1.AXIS.SECONDARY] = tslib_1.__spreadArrays(BASE_PROPERTIES, BASE_X_AXIS_PROPERTIES, BASE_SECONDARY_AXIS_PROPERTIES, CHART_TYPE_PROPERTIES, exports.OPTIONAL_STACKING_PROPERTIES, [
        "dataPoints.visible",
    ]),
    _d[axis_1.AXIS.DUAL] = tslib_1.__spreadArrays(exports.BASE_CHART_SUPPORTED_PROPERTIES, BASE_SECONDARY_AXIS_PROPERTIES, CHART_TYPE_PROPERTIES, exports.OPTIONAL_STACKING_PROPERTIES, [
        "dataPoints.visible",
    ]),
    _d);
exports.BUBBLE_CHART_SUPPORTED_PROPERTIES = tslib_1.__spreadArrays(BASE_PROPERTIES, [
    "xaxis.rotation",
    "xaxis.labelsEnabled",
    "xaxis.visible",
    "xaxis.min",
    "xaxis.max",
    "xaxis.name.visible",
    "xaxis.name.position",
    "xaxis.format",
    "yaxis.labelsEnabled",
    "yaxis.rotation",
    "yaxis.visible",
    "yaxis.min",
    "yaxis.max",
    "yaxis.name.visible",
    "yaxis.name.position",
    "yaxis.format",
]);
exports.SCATTERPLOT_SUPPORTED_PROPERTIES = [
    "dataLabels.visible",
    "grid",
    "xaxis.rotation",
    "xaxis.labelsEnabled",
    "xaxis.visible",
    "xaxis.min",
    "xaxis.max",
    "xaxis.name.visible",
    "xaxis.name.position",
    "xaxis.format",
    "yaxis.labelsEnabled",
    "yaxis.rotation",
    "yaxis.visible",
    "yaxis.min",
    "yaxis.max",
    "yaxis.name.visible",
    "yaxis.name.position",
    "colorMapping",
    "zoomInsight",
    "yaxis.format",
];
exports.PIECHART_SUPPORTED_PROPERTIES = [
    "dataLabels.visible",
    "legend",
    "colorMapping",
    "chart.verticalAlign",
];
exports.TREEMAP_SUPPORTED_PROPERTIES = ["dataLabels.visible", "legend", "colorMapping", "zoomInsight"];
exports.HEATMAP_SUPPORTED_PROPERTIES = [
    "dataLabels.visible",
    "legend",
    "yaxis.rotation",
    "yaxis.labelsEnabled",
    "yaxis.visible",
    "yaxis.name.visible",
    "yaxis.name.position",
    "xaxis.labelsEnabled",
    "xaxis.rotation",
    "xaxis.visible",
    "xaxis.name.visible",
    "xaxis.name.position",
    "colorMapping",
    "zoomInsight",
];
exports.BULLET_CHART_SUPPORTED_PROPERTIES = [
    "grid",
    "xaxis.rotation",
    "xaxis.labelsEnabled",
    "xaxis.visible",
    "xaxis.min",
    "xaxis.max",
    "xaxis.name.visible",
    "xaxis.name.position",
    "xaxis.format",
    "yaxis.rotation",
    "yaxis.labelsEnabled",
    "yaxis.visible",
    "yaxis.name.visible",
    "yaxis.name.position",
    "legend",
    "colorMapping",
    "zoomInsight",
];
exports.GEOPUSHPIN_SUPPORTED_PROPERTIES = [
    "tooltipText",
    "latitude",
    "longitude",
    "legend",
    "points.groupNearbyPoints",
    "points.minSize",
    "points.maxSize",
    "viewport.area",
    "colorMapping",
];
exports.PIVOT_TABLE_SUPPORTED_PROPERTIES = ["columnWidths"];
//# sourceMappingURL=supportedProperties.js.map